import { render, staticRenderFns } from "./EcommerceRevenueReport.vue?vue&type=template&id=08b0cc96&scoped=true"
import script from "./EcommerceRevenueReport.vue?vue&type=script&lang=js"
export * from "./EcommerceRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./EcommerceRevenueReport.vue?vue&type=style&index=0&id=08b0cc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b0cc96",
  null
  
)

export default component.exports